import { Row, Col, message, Input, Button, Form } from 'antd';
import React, { useEffect, useState } from 'react';

import styles from './LoginOTP.module.scss';
import axios from 'axios';
import { connect, useDispatch, useSelector } from 'react-redux';
import Logo from '../../components/Logo';
import { getRedirectPath } from '../../functions';
import useCountDown from 'react-countdown-hook';
import { clone, isEmpty } from 'lodash';
import OtpInput from './OtpInput';
import { useSearchParams, useNavigate } from 'react-router-dom';
import useSelection from 'antd/lib/table/hooks/useSelection';

const initialTime = 180 * 1000;
const interval = 1000;

const LoginOTP: React.FC = (props: any) => {
  const dispatch = useDispatch();
  const me = useSelector((state: any) => state.user);
  const [searchParams, setSearchParams] = useSearchParams();
  const telephone = searchParams.get('tel') || '';
  const redirect = searchParams.get('redirect') || '';
  const [timeLeft, actions] = useCountDown(initialTime, interval);
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [contentType, setContentType] = useState({
    type: 'mobile',
  });

  const [phoneNo, setPhoneNo] = useState<string>(``);
  const [refNo, setRefNo] = useState<string>(``);
  const [user, setUser] = useState<string>(``);
  const [otp, setOTP] = useState<string>('');
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const TEST_TELEPHONE_NUMBER = new RegExp(/((0)(\d{9,10}))/g);

  useEffect(() => {
    if (TEST_TELEPHONE_NUMBER.test(telephone)) {
      requestOTP(telephone)
        .then((data) => {
          setPhoneNo(telephone);
          setRefNo(data.ref);
          setUser(data.user);
          setContentType({ type: 'mobile-otp' });
          actions.start();
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.data.error.code === 'notfound') {
              message.error(
                `ไม่พบข้อมูลเบอร์โทรศัพท์ของท่าน กรุณาสมัครสมาชิก`,
                30
              );
            }
          }
        });
    }
  }, [telephone]);

  const handleOTPChange = async (value: string) => {
    setOTP(value);
  };

  const requestOTP = async (phoneNo: string) => {
    const { data } = await axios.post(
      `/sms-service/otp/send/${phoneNo}`
    );
    return data;
  };

  const onClickRequestOTP = async (values: any) => {
    setPhoneNo(values.phoneNo);
    try {
      const data = await requestOTP(values.phoneNo);
      setRefNo(data.ref);
      setUser(data.user);
      setContentType({ type: 'mobile-otp' });
      actions.start();
    } catch (err: any) {
      if (err.response) {
        if (err.response.data.error.code === 'notfound') {
          message.error(
            `ไม่พบข้อมูลเบอร์โทรศัพท์ของท่าน กรุณาสมัครสมาชิก`,
            30
          );
        }
      }
    }
  };

  const padTo2Digits = (num: number) => {
    return num.toString().padStart(2, '0');
  };

  const login = async () => {
    const { data } = await axios.post(
      `/auth/getUserByUserIdAndPhoneNo`,
      { userId: user, phoneNo }
    );

    if (data?.user?._id) {
      localStorage.setItem('token', data.token);
      localStorage.setItem('DataFixTime', 'true');
      axios.interceptors.request.use(function (config: any) {
        config.headers.Authorization = `Bearer ${data.token}`;

        return config;
      });

      dispatch({
        type: 'UPDATE_USER',
        data: data?.user,
      });

      message.success('เข้าสู่ระบบสำเร็จ!');
      setTimeout(() => {
        // const path = getRedirectPath('/');
        // const redirectPage = localStorage.getItem(
        //   'redirect_product_datail'
        // );
        // const data = clone(redirectPage);
        // localStorage.removeItem('redirect_product_datail');
        if (redirect !== null && redirect !== undefined) {
          window.location.href = redirect;
        } else {
          window.location.replace('/');
        }
      }, 1000);
    }
  };

  const onFinish = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(`/sms-service/otp/verify`, {
        user,
        pin: otp,
      });
      if (data.status === 'success') {
        login();
      }
    } catch (err: any) {
      if (err.response) {
        message.error(`รหัส OTP ไม่ถูกต้อง`, 20);
      }
    }
  };

  const onClickNewOTP = async () => {
    try {
      const data = await requestOTP(phoneNo);
      setRefNo(data.ref);
      setUser(data.user);
      actions.start();
    } catch (err: any) {
      if (err.response) {
        if (err.response.data.error.code === 'notfound') {
          message.error(
            `ไม่พบข้อมูลเบอร์โทรศัพท์ของท่าน กรุณาสมัครสมาชิก`,
            30000
          );
          setContentType({ type: 'mobile' });
        }
      }
    }
  };

  useEffect(() => {
    setMinutes(Math.floor(timeLeft / 1000 / 60));
    setSeconds((timeLeft / 1000) % 60);
  }, [timeLeft]);

  useEffect(() => {
    if (!isEmpty(me)) {
      window.location.href = '/';
    }
  }, [me]);

  const ContentTypeMobile = () => {
    if (contentType.type === 'mobile') {
      return (
        <>
          <div className={styles.header}>เข้าสู่ระบบ</div>
          <div
            className="n-text mt-4"
            style={{
              color: '#444951',
              fontSize: '18px',
              marginTop: '24px',
            }}
          >
            เข้าสู่ระบบ หรือ <a href="/register">สมัครสมาชิก</a>&nbsp;
            เพื่อเลือกซื้อวัสดุก่อสร้างและใช้บริการช่างมืออาชีพ
          </div>
          <br />
          <Form name={`requestOTPForm`} onFinish={onClickRequestOTP}>
            <Form.Item
              name={`phoneNo`}
              rules={[
                {
                  pattern: TEST_TELEPHONE_NUMBER,
                  required: true,
                  message: 'กรุณาใส่เบอร์โทรศัพท์ให้ถูกต้อง!',
                },
              ]}
            >
              <Input
                size="large"
                type="tel"
                maxLength={10}
                className={`mt-6`}
                placeholder="กรอกเบอร์มือถือ"
              />
            </Form.Item>
            <Form.Item>
              <Button
                className="mt-12"
                type="primary"
                htmlType="submit"
                block
                size="large"
                style={{ borderRadius: '8px' }}
              >
                ถัดไป
              </Button>
            </Form.Item>
          </Form>
          <div
            className="s-text mt-6"
            style={{
              color: '#444951',
              fontSize: '18px',
              marginTop: '24px',
            }}
          >
            การคลิกสร้างบัญชีเป็นการแสดงว่าคุณยอมรับข้อกำหนดและเงื่อนไขและนโยบายความเป็นส่วนตัว
          </div>
        </>
      );
    }

    return <></>;
  };

  const ContentTypeMobileOTP = () => {
    if (contentType.type === 'mobile-otp') {
      return (
        <>
          <div className={styles.header}>ใส่รหัส OTP</div>
          <div className="n-text mt-4">
            ส่งรหัส 6 หลักไปที่ {phoneNo}
          </div>
          <OtpInput
            value={otp}
            valueLength={6}
            onChange={handleOTPChange}
          />
          <div className="text-gray-darkHover mt-4 md:text-xl">
            รหัสอ้างอิง: {refNo}
          </div>
          <div className="text-gray-darkHover text-xl text-center font-semibold mt-8 md:text-3xl">
            ส่งรหัสใหม่
            {` (${padTo2Digits(minutes)}:${padTo2Digits(seconds)})`}
          </div>
          {timeLeft > 0 ? (
            <Button
              className="mt-4"
              type="primary"
              block
              size="large"
              onClick={onFinish}
            >
              เข้าสู่ระบบ
            </Button>
          ) : (
            <Button
              className="mt-4"
              type="default"
              block
              size="large"
              onClick={onClickNewOTP}
            >
              ขอรหัสอีกครั้ง
            </Button>
          )}
        </>
      );
    }

    return <></>;
  };

  return (
    <>
      <Row justify={'space-between'}>
        <Col md={24} lg={12} sm={24} xs={24} className={styles.stock}>
          <div className={styles.wrapper}></div>
        </Col>
        <Col
          md={24}
          lg={12}
          sm={24}
          xs={24}
          className={`${styles.section}`}
        >
          <div className={styles.content}>
            <div className={styles.verticalCenter}>
              {ContentTypeMobile()}
              {ContentTypeMobileOTP()}
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(LoginOTP);
